import React from 'react';
import './companyLogosSlider.css';

// Array con URLs de logotipos de ejemplo (22 items)
const companyLogos = [
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_19.png?alt=media&token=db8903ca-f370-4140-8751-ac1e641d2e94",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_18.png?alt=media&token=2320a507-93a6-4417-ac78-1e036e1af14d",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_17.png?alt=media&token=4e2b3be1-718e-42c0-bfe9-29273f959583",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_16.png?alt=media&token=f0cec200-7093-48bf-8f52-49a42571f773",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_15.png?alt=media&token=a21cac30-fe1b-41ee-ae15-106628032ab7",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_14.png?alt=media&token=a2965a13-135c-48df-b44a-f5d2cefcfa06",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_13.png?alt=media&token=9e7db9be-a5b4-4179-8bf5-6e21eabcecc2",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_12.png?alt=media&token=36b353b5-ac82-4b2d-9845-22a6a8645c9b",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_11.png?alt=media&token=e97160c4-1229-42bb-a37c-5d577ff40f2d",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_10.png?alt=media&token=50b1ddcf-250d-465e-b6a5-9dd02feeea4a",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_1.png?alt=media&token=e18b0530-623a-4c95-ba99-123c9e5660c3",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_9.png?alt=media&token=5ef94a40-92b1-462b-95d9-6789c5225de1",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_8.png?alt=media&token=afce7c13-5b51-4afa-9d8e-589f35406282",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_7.png?alt=media&token=399fd5f2-4c4a-4868-8030-2d19812234ba",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_5.png?alt=media&token=cc7b8475-530e-4aa4-ab6d-de4397163b5d",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_4.png?alt=media&token=d642d849-9f80-492c-826a-025bbec7d7b1",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_3.png?alt=media&token=fb87029b-1fcd-4466-9276-da493889f47b",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_26.png?alt=media&token=fd1e1607-29ab-4b7c-9982-2c47f24b6204",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_25.png?alt=media&token=75f18133-c432-4bd8-8453-835fc0112a6f",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_24.png?alt=media&token=911417aa-8ce5-4fe1-99ee-660a956928a7",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_23.png?alt=media&token=2b1860c8-b98d-45aa-8a71-3c76a738a934",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_22.png?alt=media&token=230cccd7-83f1-47e0-b42f-98ce84b74afc",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_21.png?alt=media&token=dbb5a806-5163-4234-bcb0-3687329d5668",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_20.png?alt=media&token=62ea3933-b70f-4078-93ff-c748a3e98eab",
  "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Fempresas%2Fcompany_2.png?alt=media&token=ccf28c3b-bf8e-494d-8399-c61ad40690b1",
];

const CompanyLogosSlider: React.FC = () => {
  return (
    <div className="w-full py-4 md:py-12 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 md:px-12">
        <div className="mb-1 md:mb-4">
          <h2 className="text-center  text-3xl md:text-4xl font-bold text-xervix-text-primary dark:text-xervix-text-primary-dark">
            Empresas que <span className="text-xervix-primary">confían</span> en nosotros
          </h2>
          <p className="text-left text-xervix-text-muted dark:text-xervix-text-muted-dark mt-2">
            Miles de empresas ya forman parte de la comunidad Xervix
          </p>
        </div>
        
        <div className="logos-slider">
          <div className="logos-slide">
            {/* Primer grupo de logos */}
            {companyLogos.map((logo, index) => (
              <div key={`logo-1-${index}`} className="logo-item">
                <img 
                  src={logo} 
                  alt={`Empresa ${index + 1}`} 
                  className="logo-image"
                />
              </div>
            ))}
            
            {/* Duplicado del grupo de logos para crear el efecto infinito */}
            {companyLogos.map((logo, index) => (
              <div key={`logo-2-${index}`} className="logo-item">
                <img 
                  src={logo} 
                  alt={`Empresa ${index + 1}`} 
                  className="logo-image"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyLogosSlider;
